<template>
  <div class="main-content" ref="sub">
    <vxe-toolbar size="mini">
      <template v-slot:buttons>
        <div style="padding-bottom: 10px">
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-save"
            @click="insertEvent()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />
            {{ $t('xTable.insert') }}
          </vxe-button>
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-delete"
            @click="deleteEvent()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-white-delete"
            />
            {{ $t('xTable.delete') }}
          </vxe-button>
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-save"
            @click="save()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-preserve"
            />
            {{ $t('xTable.save') }}
          </vxe-button>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :edit-rules="editRules"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editable }"
      :checkbox-config="{ labelField: 'name', checkMethod }"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="factorCode"
        :title="$t('creditCalculation.calculationFactorNo')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.factorCode" maxlength="32" clearable></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="factorName"
        :title="$t('creditCalculation.calculationFactorName')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.factorName" maxlength="32" clearable></el-input> </template
      ></vxe-table-column>
      <vxe-table-column
        field="isAvailable"
        :title="$t('creditCalculation.calculationFactorStatus')"
      >
        <template slot-scope="scope">
          <span>
            {{ statusData[scope.row['isAvailable']] }}
          </span>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  // import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'CalculationFactor',
    components: {
      // SearchModal,
    },
    data() {
      return {
        load: false,
        partnerTypeList: [],
        statusData: [
          this.$t('applicationCredit.msg.disable'),
          this.$t('applicationCredit.msg.startUse'),
        ],
        tableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      clear() {
        return {
          name: 'ElInput',
          props: { clearable: true, maxlength: '32' },
        };
      },
      editRules() {
        return {
          factorCode: [
            { max: '32' },
            {
              required: true,
              message: this.$t('creditCalculation.calculationFactorNoPlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          factorName: [
            { max: '32' },
            {
              required: true,
              message: this.$t('creditCalculation.calculationFactorNamePlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {
      this.getData();
    },
    methods: {
      //获取数据
      getData() {
        this.$axios.post(API.LIST_CALCULATION_FACTOR, {}).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //限制行项目checkbox是否可用
      checkMethod({ row }) {
        if (row.isAvailable == 0) {
          return false;
        }
        return true;
      },
      //新增一行
      insertEvent() {
        let userInfo = this.userInfo.userInfo;
        const record = {
          factorCode: null,
          factorName: null,
          isAvailable: '1',
          tenantCode: userInfo.userCode,
          companyCode: userInfo.companyCode,
          companyName: userInfo.companyName,
          departmentCode: userInfo.departmentCode,
          departmentName: userInfo.departmentName,
        };
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      //删除行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          // //没有保存的不掉删除接口
          selectRecords = selectRecords.filter((item) => {
            if (!item.id) {
              this.$refs.xTable.remove(item);
            }
            return item.id;
          });
          if (!selectRecords.length) {
            return;
          }
          let idList = [];
          //删除时记录删除明细id
          selectRecords.map((item) => {
            if (item.factorCode) {
              idList.push(item.factorCode + '');
            }
          });
          //调用删除接口
          this.$axios.post(API.DEL_CALCULATION_FACTOR, { codes: idList }).then((res) => {
            if (res.data.code == '0') {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.getData();
              this.$refs.xTable.removeSelecteds();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //判断行项目是否可以编辑
      editable(row) {
        if (row.row.id) {
          return false;
        } else {
          return true;
        }
      },
      //保存
      save() {
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            const data = this.$refs.xTable.getTableData().fullData;
            if (data.length) {
              this.load = true;
              this.$axios.post(API.SAVE_CALCULATION_FACTOR, { list: data }).then((res) => {
                if (res.data.code == '0') {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.getData();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                this.load = false;
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('creditCalculation.msg.addData'),
                type: 'error',
              });
            }
          }
        });
      },
    },
  };
</script>
